/**
 * 句子服务 - 处理同步课文相关的API请求
 */
import { API_BASE_URL } from '../config/apiConfig';

/**
 * 获取指定单元的句子列表
 * @param {number} unitId - 单元ID
 * @param {object} filters - 筛选条件（可选）
 * @returns {Promise<object>} 返回句子数据
 */
export const getSentencesByUnit = async (unitId, filters = {}) => {
  try {
    // 构建查询参数
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null) {
        params.append(key, filters[key]);
      }
    });

    const url = `${API_BASE_URL}/api/sentences/unit/${unitId}${params.toString() ? '?' + params.toString() : ''}`;
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    
    if (result.code !== 200) {
      throw new Error(result.message || '获取句子数据失败');
    }
    
    return result.data;
  } catch (error) {
    console.error('获取句子数据失败:', error);
    throw error;
  }
};

/**
 * 从localStorage获取选中的单元ID
 * @returns {number|null} 返回单元ID或null
 */
export const getUnitIdFromStorage = () => {
  try {
    const selectedTextbookData = localStorage.getItem('selectedTextbook');
    if (!selectedTextbookData) {
      return null;
    }
    
    const parsedData = JSON.parse(selectedTextbookData);
    return parsedData?.unit?.id || null;
  } catch (error) {
    console.error('读取localStorage失败:', error);
    return null;
  }
};

export default {
  getSentencesByUnit,
  getUnitIdFromStorage
};

